module.exports = __webpack_public_path__ + "img/13.91e68515.png";